export default __webpack_public_path__ + "2c48d5ec542e43b968e19bd8e1420728.svg";